import { useState, useEffect } from 'react';
import { fetchAdminBookmakers, updateBookmaker } from '@/api';
import { LoadingPage } from '@/components/common/Loading';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Switch } from '@/components/ui/switch';
import { Building2, Star } from 'lucide-react';

export default function BookmakerManagement() {
  const [bookmakers, setBookmakers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    fetchAdminBookmakers().then(res => { setBookmakers(res.data.bookmakers || []); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const toggleField = async (id, field, currentValue) => {
    try {
      await updateBookmaker(id, { [field]: !currentValue });
      load();
    } catch { /* ignore */ }
  };

  if (loading) return <LoadingPage />;

  return (
    <div data-testid="bookmaker-management">
      <h1 className="text-2xl font-bold tracking-tight uppercase text-slate-50 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
        <Building2 className="w-5 h-5 inline mr-2 text-blue-400" />
        Bookmaker Management
      </h1>

      <div className="space-y-2">
        {bookmakers.map(bkm => (
          <div key={bkm.id} className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 flex items-center justify-between" data-testid={`bkm-row-${bkm.id}`}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center text-base font-bold text-emerald-400">
                {bkm.name[0]}
              </div>
              <div>
                <p className="text-sm font-medium text-slate-200">{bkm.name}</p>
                <p className="text-xs text-slate-500">Priority: {bkm.priority} | Margin: {bkm.margin_avg}%</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <span className="text-xs text-slate-500">Featured</span>
                <Switch
                  checked={bkm.featured}
                  onCheckedChange={() => toggleField(bkm.id, 'featured', bkm.featured)}
                  data-testid={`featured-${bkm.id}`}
                />
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-slate-500">Active</span>
                <Switch
                  checked={bkm.active}
                  onCheckedChange={() => toggleField(bkm.id, 'active', bkm.active)}
                  data-testid={`active-${bkm.id}`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
